import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import StatCard from "./StatCard";
import ChatUsersDetails from "./ChatUsersDetails";
import { subDays, format } from "date-fns";

const ChatUsers = ({ chatUsers }) => {
  const [dailyCounts, setDailyCounts] = useState([]);
  const [labels, setLabels] = useState([]);
  const [trend, setTrend] = useState("neutral");
  const [detailsOpen, setDetailsOpen] = useState(false);

  const getTrend = (counts) => {
    const len = counts.length;
    if (len < 2) return "neutral";
    const prev = counts[len - 2];
    const current = counts[len - 1];
    if (current > prev) return "up";
    if (current < prev) return "down";
    return "neutral";
  };

  const processUserData = (users) => {
    const now = new Date();
    const dateMap = new Map();

    for (let i = 29; i >= 0; i--) {
      const d = subDays(now, i);
      const key = format(d, "yyyy-MM-dd");
      dateMap.set(key, 0);
    }

    users.forEach((user) => {
      const createdDate = format(new Date(user.createdAt), "yyyy-MM-dd");
      if (dateMap.has(createdDate)) {
        dateMap.set(createdDate, dateMap.get(createdDate) + 1);
      }
    });

    const counts = Array.from(dateMap.values());
    const labels = Array.from(dateMap.keys()).map((d) =>
      format(new Date(d), "dd MMM")
    );

    return { counts, labels };
  };

  useEffect(() => {
    if (chatUsers && chatUsers.length > 0) {
      const filtered = chatUsers.filter(
        (u) => new Date(u.createdAt) >= new Date(Date.now() - 30 * 86400000)
      );

      const { counts, labels } = processUserData(filtered);

      setDailyCounts(counts);
      setLabels(labels);
      setTrend(getTrend(counts));
    }
  }, [chatUsers]);

  return (
    <Box sx={{ width: "100%" }}>
      <StatCard
        title="Chat Users"
        value={dailyCounts.reduce((a, b) => a + b, 0).toLocaleString()}
        interval="Last 30 days"
        trend={trend}
        data={dailyCounts}
        labels={labels}
        onClick={() => setDetailsOpen(true)}
      />
      <ChatUsersDetails
        open={detailsOpen}
        onClose={() => setDetailsOpen(false)}
        chatUsers={chatUsers}
      />
    </Box>
  );
};

export default ChatUsers;
